import { type PerformanceTopPlayers } from '../performance-api.ts';
import { type SessionsServiceSession } from './sessions-service-api.ts';
import { sumTotals } from './totals.ts';

const TOP_PLAYERS_LIMIT = 5;

export const buildTopPlayers = (completed: SessionsServiceSession[]): PerformanceTopPlayers => {
  const sessionsByPlayer = new Map<string, SessionsServiceSession[]>();

  completed.forEach((session) => {
    const id = session.player_id;
    const group = sessionsByPlayer.get(id);
    if (group) group.push(session);
    else sessionsByPlayer.set(id, [session]);
  });

  const rows = [...sessionsByPlayer.entries()]
    .map(([playerId, sessions]) => {
      const { wagers, payouts } = sumTotals(sessions);
      const latest = sessions.reduce((a, b) => (a.created_at > b.created_at ? a : b));
      return {
        player_id: playerId,
        name: latest.player_name,
        sessions: sessions.length,
        wagers,
        payouts,
      };
    })
    .sort((a, b) => b.sessions - a.sessions || b.wagers - a.wagers)
    .slice(0, TOP_PLAYERS_LIMIT);

  return { unique: sessionsByPlayer.size, rows };
};
